import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { SummaryService } from '../summary/summary.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ReportAccessGuard implements CanActivate {

  constructor(private router: Router, private summaryService: SummaryService) {
  }

  /**
   * Returns true if the user is authorized to go to this route.  Otherwise, user
   * is routed to authorization failure page.
   *
   * @param route route to be activated.
   * @param state router state.
   */
  canActivate(route: ActivatedRouteSnapshot, state:RouterStateSnapshot): Observable<boolean> | boolean {

    const reportAccess = route.data.reportAccess;

    return this.summaryService.getMyAccountWithoutEmit().pipe(map(e => {

    if (e['Account']) {
      if (e['Account']['reportAccess'] === false) {
        this.router.navigate(['/sec/unauthorized']);
        return false;
      }
      return !!e['Account']['reportAccess'];
    }
    
  }, error => {
    console.warn(`got HttpError=${JSON.stringify(error)}`);
  }), catchError(() => {
    this.router.navigate(['/']);
    return of(false);
  }));

  }
}